import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import SideBar from './SideBar';

const styles = (theme) => {
  const currentNavBarHeightDesktop = theme.mixins.toolbar['@media (min-width:600px)'].minHeight;
  const currentNavBarHeightMobile = theme.mixins.toolbar.minHeight;

  return {
    container: {
      flexGrow: 1,
      display: 'flex',
      flexWrap: 'nowrap',
      position: 'relative',
      [theme.breakpoints.down('xs')]: {
        height: `calc(100vh - ${currentNavBarHeightMobile}px)`,
      },
      [theme.breakpoints.up('sm')]: {
        height: `calc(100vh - ${currentNavBarHeightDesktop}px)`,
      },
    },
  };
};

//added position prop to this so that we can override it too "inherit" in one instance in SessionsPage.tsx
//we want to come back and address this later potentially
const PageContainer = ({ classes, showSidebar = true, children, position = 'relative' }) => (
  <Grid container className={classes.container} style={{ position: position }}>
    {showSidebar && <SideBar />}
    {children}
  </Grid>
);

export default withStyles(styles)(PageContainer);
